// A star toggle for favoriting a ticket / change order. Presentation only — the
// caller owns the on/off state (see useFavorites).

export function FavoriteStar({
  on,
  onToggle,
  size = 18,
}: {
  on: boolean;
  onToggle: () => void;
  size?: number;
}) {
  return (
    <button
      type="button"
      className="btn small"
      aria-pressed={on}
      title={on ? "Remove from favorites" : "Add to favorites"}
      onClick={onToggle}
      style={{ lineHeight: 1 }}
    >
      <span aria-hidden="true" style={{ fontSize: size, color: on ? "#f59e0b" : "inherit" }}>
        {on ? "★" : "☆"}
      </span>
    </button>
  );
}
